var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.12C13.663 5.12 14.2989 4.8566 14.7678 4.38776C15.2366 3.91892 15.5 3.28304 15.5 2.62C15.5 1.95695 15.2366 1.32107 14.7678 0.852228C14.2989 0.383387 13.663 0.119995 13 0.119995C12.337 0.119995 11.7011 0.383387 11.2322 0.852228C10.7634 1.32107 10.5 1.95695 10.5 2.62C10.5 3.28304 10.7634 3.91892 11.2322 4.38776C11.7011 4.8566 12.337 5.12 13 5.12ZM0.5 1.788H9.809C9.61804 2.32726 9.61804 2.91573 9.809 3.455H0.5V1.788ZM3 6.88C2.33696 6.88 1.70107 7.14339 1.23223 7.61223C0.763392 8.08107 0.5 8.71695 0.5 9.38C0.5 10.043 0.763392 10.6789 1.23223 11.1478C1.70107 11.6166 2.33696 11.88 3 11.88C3.66304 11.88 4.29893 11.6166 4.76777 11.1478C5.23661 10.6789 5.5 10.043 5.5 9.38C5.5 8.71695 5.23661 8.08107 4.76777 7.61223C4.29893 7.14339 3.66304 6.88 3 6.88ZM15.5 10.214H6.191C6.38212 9.67476 6.38212 9.08623 6.191 8.547H15.5V10.214Z",
    fill: "#009745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.11c7429a739a425bebc52cd523a0cdff.svg";
export { ForwardRef as ReactComponent };